import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "jr-text-primary jr-text-base jr-font-medium jr-mb-5" }, "駅周辺移動元・先エリア分布", -1)
const _hoisted_2 = { class: "jr-flex jr-justify-between jr-items-end jr-border jr-border-gray-medium jr-rounded-md jr-py-5 jr-pr-5" }
const _hoisted_3 = { class: "jr-flex-1" }
const _hoisted_4 = { class: "jr-text-right jr-mb-2" }
const _hoisted_5 = { class: "jr-mr-6 jr-px-8.5 jr-py-1.5 jr-border jr-border-primary jr-text-primary jr-text-xs" }
const _hoisted_6 = { class: "jr-flex-1" }
const _hoisted_7 = { class: "jr-text-right jr-mb-2" }
const _hoisted_8 = { class: "jr-mr-6 jr-px-8.5 jr-py-1.5 jr-border jr-border-primary jr-text-primary jr-text-xs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIComparisonChart = _resolveComponent("UIComparisonChart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, "各エリア → " + _toDisplayString(_ctx.comparison.base), 1)
        ]),
        _createVNode(_component_UIComparisonChart, {
          data: _ctx.comparison.main,
          labels: _ctx.comparison.labels
        }, null, 8, ["data", "labels"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.comparison.base) + " → 各エリア", 1)
        ]),
        _createVNode(_component_UIComparisonChart, {
          "show-label": false,
          labels: _ctx.comparison.labels,
          data: _ctx.comparison.peripheral
        }, null, 8, ["labels", "data"])
      ])
    ])
  ]))
}